<script>
const channel_bdmap = "bdmap";

export default {
  channel_bdmap, // 百度地图房产渠道
}
</script>



// WEBPACK FOOTER //
// src/components/public/Global.vue